export * from './ComparedLocationBean'
